import React from 'react'
import * as StyledComponent from '../styles'

const ItemError = (props, context) => {
  return <StyledComponent.ItemError className='item-error-box'>
    <div>{props.error_message}</div>
  </StyledComponent.ItemError>
}

export default ItemError



// WEBPACK FOOTER //
// ./src/components/ItemError.js